<template>
  <p class="form-control-static">{{value}}</p>
</template>

<script>
  import mixin from './mixin';

  export default {
    name: 'f-id',
    mixins: [mixin],
  };
</script>



// WEBPACK FOOTER //
// f-id.vue?0ce86afd